import { render, staticRenderFns } from "./Timezone.vue?vue&type=template&id=24527fd8&scoped=true&"
import script from "./Timezone.vue?vue&type=script&lang=js&"
export * from "./Timezone.vue?vue&type=script&lang=js&"
import style0 from "./Timezone.vue?vue&type=style&index=0&id=24527fd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24527fd8",
  null
  
)

export default component.exports